const savingsActionTypes = {
	/*************** START ADD SAVINGS DETAILS ******************/
	ADD_SAVINGS_DETAILS_START: 'add_savings_details_start',
	ADD_SAVINGS_DETAILS_SUCCESS: 'add_savings_details_success',
	ADD_SAVINGS_DETAILS_FAILURE: 'add_savings_details_failure',
	ADD_SAVINGS_DETAILS_RESPONSE_RESET: 'add_savings_details_response_reset',
	ADD_SAVINGS_DETAILS_RESPONSE_CHANGED: 'add_savings_details_response_changed',
	/*************** END ADD SAVINGS DETAILS ******************/

	/*************** START UPDATE SAVINGS DETAILS ******************/
	UPDATE_SAVINGS_DETAILS_START: 'update_savings_details_start',
	UPDATE_SAVINGS_DETAILS_SUCCESS: 'update_savings_details_success',
	UPDATE_SAVINGS_DETAILS_FAILURE: 'update_savings_details_failure',
	UPDATE_SAVINGS_DETAILS_RESPONSE_RESET: 'update_savings_details_response_reset',
	UPDATE_SAVINGS_DETAILS_RESPONSE_CHANGED: 'update_savings_details_response_changed',
	/*************** END UPDATE SAVINGS DETAILS ******************/

	/** ***************** GET SAVINGS LIST START *********************** */
	GET_SAVINGS_LIST_START: 'get_savings_list_start',
	GET_SAVINGS_LIST_SUCCESS: 'get_savings_list_success',
	GET_SAVINGS_LIST_FAILURE: 'get_savings_list_failure',
	GET_SAVINGS_LIST_RESPONSE_RESET: 'get_savings_list_response_reset',
	GET_SAVINGS_LIST_RESPONSE_CHANGED: 'get_savings_list_response_changed',
	/** ***************** GET SAVINGS LIST END *********************** */

	/** ***************** FETCH SAVINGS DETAILS START *********************** */
	FETCH_SAVINGS_DETAILS_START: 'fetch_savings_details_start',
	FETCH_SAVINGS_DETAILS_SUCCESS: 'fetch_savings_details_success',
	FETCH_SAVINGS_DETAILS_FAILURE: 'fetch_savings_details_failure',
	FETCH_SAVINGS_DETAILS_RESPONSE_RESET: 'fetch_savings_details_response_reset',
	FETCH_SAVINGS_DETAILS_RESPONSE_CHANGED: 'fetch_savings_details_response_changed',
	/** ***************** FETCH SAVINGS DETAILS END *********************** */

	/** ***************** DELETE SAVINGS DETAILS START *********************** */
	DELETE_SAVINGS_DETAILS_START: 'delete_savings_details_start',
	DELETE_SAVINGS_DETAILS_SUCCESS: 'delete_savings_details_success',
	DELETE_SAVINGS_DETAILS_FAILURE: 'delete_savings_details_failure',
	DELETE_SAVINGS_DETAILS_RESPONSE_RESET: 'delete_savings_details_response_reset',
	DELETE_SAVINGS_DETAILS_RESPONSE_CHANGED: 'delete_savings_details_response_changed',
	/** ***************** DELETE SAVINGS DETAILS END *********************** */

	/** ***************** FETCH ALL SAVINGS LIST START *********************** */
	FETCH_ALL_SAVINGS_START: 'fetch_all_savings_start',
	FETCH_ALL_SAVINGS_SUCCESS: 'fetch_all_savings_success',
	FETCH_ALL_SAVINGS_FAILURE: 'fetch_all_savings_failure',
	FETCH_ALL_SAVINGS_RESPONSE_RESET: 'fetch_all_savings_response_reset',
	FETCH_ALL_SAVINGS_RESPONSE_CHANGED: 'fetch_all_savings_response_changed',
	/** ***************** FETCH ALL SAVINGS LIST END *********************** */
};

export default savingsActionTypes;
